"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Constants_1 = require("@src/app/commons/Constants");
const DEBUG_1 = require("@src/DEBUG");
const base_class_1 = require("./base.class");
DEBUG_1.DEBUG.open('/xs/controllers/await');
// import * as _ from 'lodash'
// import { Observable, of, ReplaySubject, Subject, Subscription } from 'rxjs';
/*
  Eventify a service / helper / controller / whatever
*/
class XsAwait extends base_class_1.XsBaseClass {
    constructor(items, resolve, config = {}) {
        super(config);
        this.debugId = 'AWAIT_CLASS';
        this._config_default = {
            delayTime: 200,
            maxTime: 10000
        };
        this.context = null;
        this.uuid = this.uuidv4();
        // our items to check
        this.items = null;
        // the main Promise
        // p:any = null;
        this.resolve = null;
        // isResolved?
        this.isResolved = false;
        // sum up the total time we've waited
        this.totalTime = 0;
        if (this._config.context)
            DEBUG_1.DEBUG.log('/xs/controllers/await');
        this.parentClass = this.constructor.name;
        this.__log('CONSTRUCTOR', items);
        // console.log('##await ['+this.uuid+'] start', items, this._config );
        // our items to check
        this.items = items;
        // transfer the Promise and resolve
        this.resolve = resolve;
        // start checking
        this.check();
    }
    // factory function
    static waitFor(these, delayTime = 200) {
        return new Promise(resolve => {
            const inst = new XsAwait(these, resolve, { delayTime: delayTime });
        });
    }
    static until(these, context = null, delayTime = 200) {
        return new Promise(resolve => {
            const inst = new XsAwait(Array.isArray(these) ? these : [these], resolve, { context: context, delayTime: delayTime });
        });
    }
    check() {
        const me = this;
        if (this.checkItems()) {
            this.__log('check() RESOLVE');
            // console.log('##await ['+this.uuid+'] took '+this.totalTime+'ms ', this );
            this.resolve(this.items);
        }
        else {
            this.__log('check() again ...');
            if (this.totalTime > this._config.maxTime) {
                console.log('%c ##await [' + this.uuid + '] timeout after ' + this.totalTime + 'ms ', Constants_1.Constants._red, this);
            }
            else {
                setTimeout(() => { me.check(); me.totalTime = me.totalTime + me._config.delayTime; }, this._config.delayTime);
            }
        }
    }
    checkItems() {
        let ret = false;
        try {
            if (this.items && this.items.length) {
                const max = this.items.length;
                let cur = 0;
                let previous = true;
                this.items.forEach(item => {
                    let itemCheck = false;
                    let itemChildrenCheck = false;
                    let itemChildrenTest = false;
                    let type = typeof item;
                    // console.log ( 'await TRY', type );
                    if (type == 'string') {
                        // incoming path in the form of a string
                        if (this.reach(item, this._config.context)) {
                            cur++;
                            previous = true;
                        }
                    }
                    else {
                        if (item.hasOwnProperty('object')) {
                            if (item.object) {
                                itemCheck = true;
                            }
                        }
                    }
                    if (itemCheck && previous) {
                        previous = false;
                        if (item.hasOwnProperty('children')) {
                            itemChildrenTest = true;
                            let itemMax = item.children.length;
                            let itemCur = 0;
                            if (item.children && item.children.length) {
                                item.children.forEach(child => {
                                    if (item.object && item.object[child]) {
                                        itemCur++;
                                    }
                                });
                            }
                            if (itemCur == itemMax) {
                                itemChildrenCheck = true;
                            }
                        }
                        else if (item.hasOwnProperty('child')) {
                            itemChildrenTest = true;
                            if (item.object && item.object[item.child]) {
                                itemChildrenCheck = true;
                            }
                        }
                    }
                    if (itemChildrenTest) {
                        if (itemCheck && itemChildrenCheck) {
                            cur++;
                            previous = true;
                        }
                    }
                    else {
                        if (itemCheck) {
                            cur++;
                            previous = true;
                        }
                    }
                });
                if (cur == max) {
                    ret = true;
                }
                this.__log('checkItems() done', [ret, this.items]);
            }
        }
        catch (error) {
            // console.log('## await error', error, this );
        }
        return ret;
    }
    // reach sets properties of the current object (this) according to a path (delimited by '.');
    //  - reach ( 'myProp', value ) = this.myProp = value
    //  - reach ( 'someObj.subObj.myValue', value ) = this.someObj.subObj.myValue = value
    reach(path = '', sofar = null, depth = 0) {
        // if ( !depth ) { console.log ( 'await reach('+path+') START', sofar); }
        if (path.indexOf('.') !== -1) {
            let token = path.split('.')[0];
            let after = path.substring(path.indexOf('.') + 1);
            // any objects to traverse into?
            if (sofar[token]) {
                return this.reach(after, sofar[token], depth + 1);
            }
            else {
                // console.log ( 'await reach() FAILED at depth ['+depth+']', path );
                return null;
            }
        }
        else {
            if (sofar[path]) {
                // console.log ( 'await reach() DELIVERED at depth ['+depth+']', sofar[path] );
                return sofar[path];
            }
            else {
                // console.log ( 'await reach() FAILED at depth ['+depth+']', path );
                return null;
            }
            return sofar[path];
        }
    }
    uuidv4() {
        return 'xxxx-0yx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        });
    }
}
exports.XsAwait = XsAwait;
